var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16699 4.22656H2.50033C2.1467 4.22656 1.80756 4.36704 1.55752 4.61709C1.30747 4.86714 1.16699 5.20627 1.16699 5.5599V11.5599C1.16699 11.9135 1.30747 12.2527 1.55752 12.5027C1.80756 12.7528 2.1467 12.8932 2.50033 12.8932H8.50033C8.85395 12.8932 9.19309 12.7528 9.44313 12.5027C9.69318 12.2527 9.83366 11.9135 9.83366 11.5599V10.8932",
    stroke: "#032A4A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 2.8959L11.1667 4.8959M12.09 3.95257C12.3526 3.69001 12.5001 3.33389 12.5001 2.96257C12.5001 2.59125 12.3526 2.23514 12.09 1.97257C11.8274 1.71001 11.4713 1.5625 11.1 1.5625C10.7287 1.5625 10.3726 1.71001 10.11 1.97257L4.5 7.56257V9.56257H6.5L12.09 3.95257Z",
    stroke: "#032A4A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0bb562b268023adb1135d27ddba54e7c.svg";
export { ForwardRef as ReactComponent };